import { dateToTimestamp } from 'shared/helpers/parsers/date';

const parseCalendarNoteData = values => ({
  noteContents: values.noteContents,
  startDate: dateToTimestamp(values.startDate),
  endDate: dateToTimestamp(values.endDate),
});

export { parseCalendarNoteData };
